import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TreatmentCategories.scss';
import { LanguageContext } from '../../context/LanguageContext';
import { getCategories } from '../../services/categoryService';

// Türkçe karakter düzeltme fonksiyonu
const fixTurkishChars = (str) => {
    if (!str) return '';
    
    const turkishChars = {
        'Ä°': 'İ',
        'Ä±': 'ı',
        'ÅŸ': 'Ş',
        'ÄŸ': 'ğ',
        'Ä': 'Ğ',
        'Ã¼': 'ü',
        'Ãœ': 'Ü',
        'Ã¶': 'ö',
        'Ã–': 'Ö',
        'Ã§': 'ç',
        'Ã‡': 'Ç',
        'DiÅŸ': 'Diş',
        'HekimliÄŸi': 'Hekimliği',
        'iÄŸi': 'iği'
    };

    return str.replace(
        new RegExp(Object.keys(turkishChars).join('|'), 'g'),
        match => turkishChars[match]
    );
};

const TreatmentCategories = ({ onCategoryChange, activeCategory = 'estetik-dis-hekimligi' }) => {
    const { currentLang } = useContext(LanguageContext);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const loadCategories = async () => {
            try {
                setLoading(true);
                const data = await getCategories();
                if (data && data.length > 0) {
                    // Kategorileri dönüştürürken Türkçe karakterleri düzelt
                    const processedCategories = data.map(cat => ({
                        ...cat,
                        name: fixTurkishChars(cat.name),
                        nameEn: cat.nameEn
                    }));
                    
                    // Özel sıralama: Estetik Diş Hekimliği, Pedodonti, İmplant, Ortodonti, diğerleri...
                    const sortedCategories = [];
                    const priorityOrder = [
                        'estetik-dis-hekimligi',
                        'pedodonti',
                        'implant-tedavileri',
                        'ortodonti',
                        'agiz-cene-cerrahisi'
                    ];
                    
                    // Önce priority kategorilerini ekle
                    priorityOrder.forEach(identifier => {
                        const category = processedCategories.find(cat => cat.identifier === identifier);
                        if (category) {
                            sortedCategories.push(category);
                        }
                    });
                    
                    // Kalan kategorileri ekle
                    processedCategories.forEach(cat => {
                        if (!priorityOrder.includes(cat.identifier)) {
                            sortedCategories.push(cat);
                        }
                    });
                    
                    setCategories(sortedCategories);
                }
            } catch (error) {
                console.error('Kategoriler yüklenirken hata:', error);
            } finally {
                setLoading(false);
            }
        };

        loadCategories();
    }, []);

    const handleCategoryClick = (categoryId) => {
        if (onCategoryChange) {
            onCategoryChange(categoryId);
        }
        // URL'ı güncelle
        const basePath = currentLang === 'tr' ? '/tedaviler' : '/treatments';
        navigate(`${basePath}?category=${categoryId}`);
    };

    if (loading) {
        return <div>Yükleniyor...</div>;
    }

    return (
        <section className="treatment-categories">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="categories-wrapper">
                            <div className="categories-scroll">
                                {categories.map((category) => (
                                    <button
                                        key={category.id}
                                        className={`category-btn ${activeCategory === category.identifier ? 'active' : ''}`}
                                        onClick={() => handleCategoryClick(category.identifier)}
                                    >
                                        {currentLang === 'tr' ? fixTurkishChars(category.name) : category.nameEn}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TreatmentCategories; 